import React, { useEffect, useState } from "react";
import ContainerDashboard from "../../components/layouts/ContainerDashboard";
import CardRecentOrders from "../../components/shared/cards/CardRecentOrders";
import CardStatics from "../../components/shared/cards/CardStatics";
import Loader from "../Loader";
import config, { axiosInstance } from "../Config";
import LessonsTable from "../Lessions/LessonsTable";
import secureLocalStorage from "react-secure-storage";
import { toast } from "react-toastify";
import { Modal } from "antd";
import swal from "sweetalert";
import LessonSlots from "../Lessions/LessonSlots";
import moment from "moment";
import { Link } from "react-router-dom";

const filterSlots = (data) => {
    // Get today's and tomorrow's dates
    const today = moment().startOf('day');
    const tomorrow = moment().add(1, 'days').startOf('day');
    const currentTime = moment(); // current time

    // Create a new array to store the filtered slots
    let filteredSlots = [];

    // Process each item
    data.forEach(item => {
        let slots = [];
        try {
            if (item.slots){
                // item?.slots?.includes(`\\`) ? JSON.parse(JSON.parse(item?.slots)) : 
                
                slots = item?.slots ? JSON.parse(item?.slots) : [];
                // Parse the stringified JSON for slots
            }
        } catch (error) {
            console.error("Error parsing slots:", error);
            return; // In case of error, skip the current item
        }

        // Filter the slots and map custom data
        const customSlotsData = slots
            ?.filter(slot => {
                const slotDate = moment(slot.date, 'DD-MM-YYYY');
                const slotStartTime = moment(slot.time.split(' - ')[0], 'hh:mm A'); // Extract start time

                // Check if the slot is for today or tomorrow
                const isTodayOrTomorrow = slotDate.isSame(today, 'day') || slotDate.isSame(tomorrow, 'day');

                // Exclude past slots for today
                if (slotDate.isSame(today, 'day') && slotStartTime.isBefore(currentTime)) {
                    return false; // Exclude slots that are already passed for today
                }

                // Keep valid slots for today and tomorrow
                return isTodayOrTomorrow;
            })
            .map(slot => {
                return {
                    slotId: slot.id,
                    lessonid: item?.id,
                    date: slot.date,
                    time: slot.time,
                    status: slot.status,
                    customerFeedback: slot.customerFeedback,
                    instructorFeedback: slot.instructorFeedback,
                    cartype: item.cartype, // Custom data (car type from the parent item)
                    customername: item?.user?.name,
                    courseTitle: item.cources.title, // Custom data (course title from the parent item)
                    TotalHour: (Number(item?.cources?.theory) + Number(item?.cources?.practical)),
                    totalslots: slots.length,
                    Lesson: item,
                    completedslots: slots?.filter((item) => item?.status === 0).length
                };
            });

        // Add the filtered slots for this item to the filteredSlots array
        filteredSlots = filteredSlots.concat(customSlotsData);
    });

    // Return only the filtered slots for today and tomorrow
    return filteredSlots;
};

const Index = () => {

    const users = secureLocalStorage.getItem("credentials");
    const [Lessons, setLessons] = useState([])
    const [addModal, setAddModal] = useState(false)
    const [screenshotImage, setScreenshotImage] = useState('')
    const [screenshotLink, setScreenshotLink] = useState('')
    const [currentlesson, setcurrentlesson] = useState([]);
    const [Slotsdata, setSlotsData] = useState([])

    const [sessionCount, setSessionCount] = useState()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        window.scrollTo(0, 0)
        getcources()
        getDaysInfo();
    }, [])


    const [data, setData] = useState([])

    function getDaysInfo() {
        setLoading(true)

        axiosInstance.get(`/get-slots/${users?.id}`, {
            headers: {
                Authorization: `Bearer ${users?.token}`
            }
        })
            .then(res => {
                // console.log('days', res.data)
                const fullWeekData = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => {

                    const existingSlot = res?.data?.Slots ? res?.data?.Slots.find(slot => slot.days === day) : "";
                    if (existingSlot) {
                        return existingSlot;  // If there's a slot for this day, keep the existing slot
                    } else {
                        return {
                            id: null,  // If no slot exists, set id to null
                            instructorid: users?.id,
                            days: day,
                            slots: "[]",  // Empty array for slots
                            status: "1"
                        };
                    }
                });
                setData(fullWeekData.filter((slot) => slot?.slots.length > 0 && Number(slot?.status) === 0))
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    function getcources() {
        setLoading(true)
        axiosInstance.post(`get-usrlesson`, {
            instructorid: users?.id,
            type: 0
        }, {
            headers: {
                Authorization: `Bearer ${users?.token}`
            }
        })
            .then(res => {
                // Reverse the newData array
                const reversedData = res.data.lesson.reverse(); // Make sure not to mutate the original array
                // Set reversed data to both states
                const Data = res?.data?.lesson.filter(lesson => lesson?.instacceptance === null)
                setLessons(Data);

                const SlotsData = res?.data?.lesson
                    .filter(lesson => lesson?.instacceptance === "0")
                    .sort((a, b) => moment(a.date, "DD-MM-YYYY") - moment(b.date, "DD-MM-YYYY"));

                const Slots = filterSlots(SlotsData);
                setSlotsData(Slots);

                setSessionCount(reversedData.length);
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    const handleScreenShotImage = (e) => {
        setScreenshotImage(e.target.files[0])
        // generating image link for instant view
        const reader = new FileReader();
        reader.onloadend = () => {
            setScreenshotLink(reader.result);
        };
        if (e.target.files[0])
            reader.readAsDataURL(e.target.files[0]);
    }

    const handleClaimAmt = async (e) => {
        e.preventDefault();
        try {
            setLoading(true)
            const formData = new FormData()
            formData.append("instructorid", users?.id)
            formData.append("lessonid", currentlesson.id)
            formData.append("proof", screenshotImage);

            const res = await axiosInstance.post('add-claim', formData, {
                headers: {
                    Authorization: `Bearer ${users?.token}`,
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                }
            })

            if (res?.data?.success === true) {
                toast.success('Claim Request Sent !');
                setLoading(false)
            }
            else {
                toast.error('something went wrong!');
                setLoading(false);
            }


        } catch (error) {
            console.log(error)
            toast.error('Something went wrong !');
            setLoading(false)
        }
        setAddModal(false)
    }

    const handleStatus = (id, value) => {
        swal({
            title: "Are you sure?",
            text: `You want to change status of this lesson.`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    setLoading(true)

                    const formData = {
                        lessonid: id,
                        status: value,
                    }

                    axiosInstance.post('update-lessonstatus', formData, {
                        headers: {
                            Authorization: `Bearer ${users?.token}`
                        }
                    })
                        .then((response) => {
                            if (response.data.success === true) {
                                swal("", "Lesson Status Changed Successfully", "success")
                                setTimeout(() => {
                                    getcources();
                                }, 1000);
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                            swal("", "Something Went Wrong!", "error")
                        })
                        .finally(() => setLoading(false))
                }
            });
    }

    return (
        <>
            {loading && <Loader />}
            <ContainerDashboard title="Dashboard" description="Everything here">
                <section className="ps-dashboards" id="homepages">
                    <div className="row justify-content-between align-items-center">

                        <div className="col-12">
                            <div className="bg-gradientt rounded-4 p-4">
                                <div className="rounded-3 mb-5">
                                    <div className="row justify-content-between">
                                        <div className="col-12">
                                            <CardStatics sessionCount={sessionCount} availableDay={data} />
                                        </div>
                                    </div>

                                    <div className="mt-5 pt-4">
                                        <CardRecentOrders heading="Upcoming Lessons Slots" link={`${config.appUrl}lessons`} >
                                            <LessonSlots
                                                data={Slotsdata}
                                            />
                                        </CardRecentOrders>
                                    </div>

                                    <div className="mt-5 pt-4">
                                        <CardRecentOrders heading="Pending Lessons" link={`${config.appUrl}lessons`} >
                                            <LessonsTable
                                                data={Lessons.slice(0, 3)}
                                                setData={setLessons}
                                                lessonData={Lessons}
                                                // setLessonData={}
                                                // setSlotsModal={}
                                                actions={false}
                                                setAddModal={() => setAddModal(true)}
                                                setcurrentlesson={setcurrentlesson}
                                                handleStatus={handleStatus}
                                                fetchdata={getcources}
                                            />
                                            <div className="ps-card__footer text-end d-flex justify-content-end pt-4">
                                                <Link to={`${config.appUrl}lessons`} className="ps-card__morelink fs-4">
                                                    View All Lessons
                                                    <i className="icon icon-chevron-right"></i>
                                                </Link>
                                            </div>
                                        </CardRecentOrders>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                {/* Add */}
                <Modal
                    open={addModal}
                    title="Claim your amount"
                    centered
                    onCancel={() => setAddModal(false)}
                    width={600}
                    bodyStyle={{ padding: '0' }}
                    footer={null}
                >
                    <div className="bg-gradientt p-4 pb-5">
                        <form onSubmit={handleClaimAmt}>
                            <div className='row'>
                                <div className="col-12 px-4">
                                    <div >
                                        <div className="input-field ">
                                            <label htmlFor="screenshot" className='label'>
                                                <input type="file" id="screenshot"
                                                    required
                                                    onChange={handleScreenShotImage}
                                                    placeholder="Proof of completion" className='pb-2 ' />
                                                <span>Proof of completion (Screenshot)  <i className='text-danger'>*</i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12 px-4'>
                                    <img src={screenshotLink} alt="" className='w-25' />
                                </div>

                                <div className='col-md-12 ps-4 mt-4'>
                                    <button type="submit" className="button btn-green color-white" >
                                        Request to claim</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal>

            </ContainerDashboard>
        </>
    );
};

export default Index;
